export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('app:mounted', () => {
    for (const link of document.querySelectorAll('link[rel="stylesheet"][data-deferred-css][media="print"]')) {
      link.setAttribute('media', 'all')
      link.removeAttribute('data-deferred-css')
    }
  })
})
